<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>Accetta Termini e Condizioni</h2>

<mat-dialog-content>
  <p class="izy-terms-message">
    Per inviare la fattura al server devi accettare i termini del Servizio.
  </p>

  <!-- Il link ai termini e' un'azione secondaria: pillola bianca bordata nero,
       come le altre azioni di supporto dell'app. Apre in una scheda nuova, e
       l'icona lo dichiara. -->
  @if (organization_source === 'BEIZY') {
    <button
      mat-stroked-button
      type="button"
      (click)="legalConditionsRedirect()"
      class="izy-button-ghost izy-button-ghost--info custom-button-border izy-terms-link">
      <mat-icon>open_in_new</mat-icon>
      Termini e condizioni di Beizy
    </button>
  }

  <!-- Il titolare del trattamento cambia con l'organizzazione: e' il dato che
       l'utente sta autorizzando, quindi va nominato per esteso. -->
  @if (organization_source === 'BEIZY') {
    <p class="izy-terms-consent">
      Autorizzo IZY Srl al trattamento dei dati che sto per inviare. Confermo
      che le informazioni inserite sono veritiere e accetto i Termini e
      Condizioni:
    </p>
  } @else if (organization_source === 'CAF UIL Toscana') {
    <p class="izy-terms-consent">
      Autorizzo CAF UIL Toscana al trattamento dei dati che sto per inviare.
      Confermo che le informazioni inserite sono veritiere e accetto i Termini
      e Condizioni:
    </p>
  }

  <!-- La spunta obbligatoria in un riquadro a se', come nel dialog di conferma
       condiviso: e' il cancello dell'invio, non una riga di testo in mezzo al
       messaggio. -->
  <div class="izy-confirm-box izy-sharp-bl">
    <mat-checkbox [(ngModel)]="confirmed" color="primary">
      <span class="fw-bold">Confermo quanto riportato e accetto</span>
    </mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <!-- L'azione della schermata: petrol pieno bordato nero, spenta finche' la
       spunta non c'e'. -->
  <button
    matButton="filled"
    type="button"
    [disabled]="!confirmed"
    (click)="confirm()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
